module.exports = __webpack_public_path__ + "static/media/186.85af99d3.jpg";